import { BrowserModule } from '@angular/platform-browser';
import { OrderModule } from 'ngx-order-pipe';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MatButtonModule, MatSnackBarModule, MatDialogModule, MatRadioModule, MatChipsModule, MatCheckboxModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxCaptchaModule } from 'ngx-captcha';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './routers.module';


// page component
import { DataComponent } from './constant/data.component';
import { ApiAwards } from './config/api.component';
import { HomeComponent} from './home/home.component';
import { DashboardComponent} from './dashboard/dashboard.component';
import { NomineeComponent } from './dashboard/nominee.component';
import { FinalComponent, DialogViewComponent, OTPViewComponent } from './final/final.component';
import { CategoryComponent } from './dashboard/category.component';
import { ImagePreloadDirective } from './config/img.directive';
import { CountdownModule } from 'ngx-countdown';
import { CountdownConfig } from 'ngx-countdown/src/countdown.config';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DashboardComponent,
    NomineeComponent,
    CategoryComponent,
    FinalComponent,
    DialogViewComponent,
    OTPViewComponent,
    ImagePreloadDirective
  ],
  entryComponents: [
    DialogViewComponent,
    OTPViewComponent
  ],
  imports: [
    BrowserModule,
    OrderModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDialogModule,
    NgbModule,
    MatRadioModule,
    MatChipsModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    CountdownModule
  ],
  providers: [
    DataComponent,
    ApiAwards
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(router: Router) {
    //console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}
